import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Eye, SignOut } from '@phosphor-icons/react';

export default function ImpersonationBanner() {
  const { isImpersonating, impersonationData, exitImpersonation } = useAuth();

  if (!isImpersonating || !impersonationData) return null;

  return (
    <div className="bg-orange-500 text-white text-xs font-medium flex items-center justify-center gap-3 py-2 px-4 z-[9999] relative select-none">
      <Eye size={14} weight="bold" />
      <span>
        Admin View: You are viewing as{' '}
        <strong>{impersonationData.dealership_name}</strong>
        {impersonationData.user_name && <> &mdash; {impersonationData.user_name}</>}
      </span>
      <button
        onClick={exitImpersonation}
        className="ml-2 flex items-center gap-1.5 bg-white/20 hover:bg-white/30 rounded-md px-2.5 py-1 transition-colors font-semibold"
        data-testid="exit-impersonation-btn"
      >
        Exit Demo <SignOut size={12} weight="bold" />
      </button>
    </div>
  );
}
